module.exports = __webpack_public_path__ + "img/money-up.de538637.png";